import { ArrowForwardIos, ContentCopy, Delete, DynamicFeed } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const buttons = data?.arrayButtons || [];
  const hasFallback = !!data?.fallbackMessage;

  return (
    <div
      style={{
        backgroundColor: "#FAFBFF",
        padding: "12px",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
        border: "1px solid rgba(0, 168, 132, 0.3)",
        width: "180px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(45deg, #00a884, #008e76)",
          width: "16px",
          height: "16px",
          top: "50%",
          left: "-8px",
          cursor: 'pointer',
          border: "2px solid #ffffff"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "1px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(180deg)"
          }}
        />
      </Handle>

      <div
        style={{
          position: "absolute",
          right: "8px",
          top: "8px",
          display: "flex",
          gap: "4px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "14px", 
            height: "14px", 
            color: "#94a3b8",
            cursor: "pointer",
            "&:hover": { color: "#00a884" }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "14px", 
            height: "14px", 
            color: "#94a3b8",
            cursor: "pointer",
            "&:hover": { color: "#ef4444" }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "8px"
        }}
      >
        <DynamicFeed
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "6px",
            color: "#00a884"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "14px",
          fontWeight: "600"
        }}>
          Botões
        </div>
      </div>

      <div style={{ 
        color: "#374151", 
        fontSize: "12px",
        lineHeight: "1.4",
        maxHeight: "60px",
        overflowY: "auto",
        padding: "6px",
        backgroundColor: "#f8fafc",
        borderRadius: "4px",
        border: "1px solid #e2e8f0",
        marginBottom: "8px"
      }}>
        {data.message}
      </div>

      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        gap: "4px"
      }}>
        {buttons.map(option => (
          <div
            key={option.number}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 8px",
              backgroundColor: "#E8F6F2",
              borderRadius: "4px",
              border: "1px solid rgba(0, 168, 132, 0.2)",
              position: "relative"
            }}
          >
            <div style={{
              fontSize: "12px",
              color: "#4b5563",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              maxWidth: "calc(100% - 24px)",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis"
            }}>
              <span style={{
                backgroundColor: "#00a884",
                color: "#ffffff",
                minWidth: "16px",
                height: "16px",
                borderRadius: "3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "600"
              }}>
                {option.number}
              </span>
              <span style={{
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}>
                {option.value}
              </span>
            </div>

            <Handle
              type="source"
              position="right"
              id={"b" + option.number}
              style={{
                background: "linear-gradient(45deg, #00a884, #008e76)",
                width: "16px",
                height: "16px",
                right: "-8px",
                cursor: 'pointer',
                border: "2px solid #ffffff"
              }}
              isConnectable={isConnectable}
            >
              <ArrowForwardIos
                sx={{
                  color: "#ffffff",
                  width: "10px",
                  height: "10px",
                  marginLeft: "1px",
                  marginBottom: "1px",
                  pointerEvents: 'none'
                }}
              />
            </Handle>
          </div>
        ))}
      </div>

      <Handle
        type="source"
        position="bottom"
        id="a"
        style={{
          background: "linear-gradient(45deg, #fb923c, #f97316)",
          width: "16px",
          height: "16px",
          bottom: "-8px",
          left: "50%",
          transform: "translateX(-50%)",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "1px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(90deg)"
          }}
        />
      </Handle>
    </div>
  );
});
